module.exports = __webpack_public_path__ + "static/media/detail_chest_xray_pg1.2d19bb4b.png";